module.exports = __webpack_public_path__ + "img/mobigo.cba7cd9e.svg";